export default __webpack_public_path__ + "static/media/4BMW5Series.26a4cd10.jpg";